export default __webpack_public_path__ + "static/media/signIn-img1.9e3e7b57.jpg";